import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { redirectIfViewer } from 'cio/utils/route-access';

export default class WorkspacesRoute extends Route {
  crumb() {
    return {
      name: 'Workspaces',
      path: this.routeName,
      helpLabel: 'using workspaces',
      helpUrl: 'https://learn.customer.io/documentation/workspaces.html',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfViewer(this, transition);
  }
}
